import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';

/**
 * LogoBlock
 * @props   {string} header  Header for the comment block
 * @props   {Array} logoUrls  List of logo urls
 */

const BlockWrapper = styled.div`
  font-family: ${props => props.theme.fonts.secondary};
  padding: ${props => props.theme.margins.xs} ${props => props.theme.margins.xs} ${props => props.theme.margins.xxl};
`;

const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    align-items: center;
    padding: ${props => props.theme.margins.xs};
  }
`;

const Header = styled.p`
  color: ${props => props.theme.colors.primary2};
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.theme.fontSizes.sm};
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    align-items: center;
    flex-direction: row;
    max-width: 470px;
    text-align: left;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    align-items: center;
    max-width: 620px;
  }
`;

const LogoList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-flow: wrap;
  max-width: 800px;
  padding-top: ${props => props.theme.margins.xxl};

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: row;
  }
`;

const LogoItem = styled.li`
  display: flex;
  justify-content: center;
  padding-bottom: ${props => props.theme.margins.sm};
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    width: 25%;
    padding-left: ${props => props.theme.margins.xxl};

    img {
      width: 150px;
    }

    &:nth-of-type(1) {
      padding-left: 0;
    }
  }
`;

function renderLogos(logos) {
  return logos.map((logoUrl, i) => {
    return (
      <LogoItem key={`log-block-${i}`}>
        <img alt={logoUrl} src={logoUrl} />
      </LogoItem>
    )
  })
};

function LogoBlock(props) {
  const { header, logoUrls } = props.data;

  return (
    <BlockWrapper>
      <BlockContainer>
        <Header>{header}</Header>
        <LogoList>
          {renderLogos(logoUrls)}
        </LogoList>
      </BlockContainer>
    </BlockWrapper>
  )
}

export default withTheme(LogoBlock);